import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-length-selector',
  templateUrl: './time-length-selector.component.html',
  styleUrls: ['./time-length-selector.component.css']
})
export class TimeLengthSelectorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
